const translation = {
  home: {
    hero: {
      1: "Hvert øye er et",
      2: "mesterverk",
      3: "Høyoppløselig Iris Fotografering på et øyeblikk",
      4: "Fra 599,-",
    },
    button: {
      findUs: "Finn Oss",
      moreAboutConcept: "Se produkter",
      openMap: "Se på kart",
      book: "Bestill time",
      bookNow: "Book nå!",
      seeMoreQuestions: "Se flere spørsmål",
      contactUs: "Kontakt oss",
    },
    conceptText: {
      1: {
        title: "Foto",
        text: "Med vårt toppmoderne utstyr er prosessen rask, enkel og helt komfortabel. Det er bare et vanlig bilde, men resultatet er ekstraordinært.",
      },
      2: {
        title: "Redigering",
        text: "Våre eksperter optimaliserer bildet ditt nøye, eliminerer eventuelle lysrefleksjoner og setter iris mot en kontrastfylt svart bakgrunn. Dette tar ca 30 minutter.",
      },
      3: {
        title: "Trykk",
        text: "Ditt personlige irisportrett blir deretter brakt til liv, trykt i uovertruffen kvalitet på det materialet og i den størrelsen du foretrekker.",
      },
    },
    findUs: {
      title: "Finn Oss",
      wednesday: "Onsdag 17:30 - 21:30",
      thursday: "Torsdag 17:30 - 21:30",
      saturday: "Lørdag 12:00 - 18:00",
      alwaysBook:
        "Vi anbefaler alltid å booke time, hvis ikke kan det være vi ikke er åpent.",
      partnership: {
        title: "Partnerskap",
        text: "Vi ser etter partnere i andre byer! Ønsker du å åpne din egen Instant Iris-butikk, med hjelp til oppstart og markedsføring? Ta kontakt så tar vi en prat.",
      },
    },
    effects: {
      title: "Effekter",
      subtitle:
        "Velg antall iris og bla gjennom effektene vi kan lage for deg.",
      tabs: {
        solo: "Solo",
        duo: "Duo",
        trio: "Trio",
        quad: "Kvadruppel",
        quintuple: "Kvintuppel",
      },
      prev: "Forrige effekt",
      next: "Neste effekt",
    },
    giftCardBanner: "🎁 Kjøp digitale gavekort her",
  },
  FAQ: {
    title: "FAQ",
    title2: "Lurer du på noe?",
    faqs: [
      {
        question: "Må jeg booke på forhånd?",
        answer:
          "Det er lurt! Vi er som regel bare der når vi har avtaler, så det er lurt å booke på forhånd.",
      },
      {
        question: "Selger dere gavekort?",
        answer:
          "Såklart! Du kan kjøpe digitale gavekort direkte på nettsiden vår under Gavekort.",
      },
      {
        question: "Er det ubehagelig?",
        answer:
          "Nei! Vi er aldri borti øyet ditt. Det er et helt vanlig fotografisk kamera som tar bildet.",
      },
      {
        question: "Tar det lang tid?",
        answer:
          "Nei! Det hele gjøres på 15 minutt til en halvtime. Ventetid overstiger sjeldent 15 minutt, og vi har en hyggelig lounge.",
      },
      {
        question: "Får jeg produktet med en gang?",
        answer:
          "Ja! Vi printer og rammer inn bildet på timen om du vil det. For større produkter i andre materialer får du det i posten innen ca 2 uker.",
      },
    ],
  },
  concept: {
    title: "Produkter",
    photo:
      "Ved hjelp av topp-moderne utstyr for foto, fanger vi det unike i hvert øye.",
    edit: "I redigeringsfasen bruker vi en spesiell teknikk for å fremheve øyets detaljer og farger uten å endre på det naturlige utseendet.",
    print:
      "Ved hjelp av toppmoderne utstyr, leverer vi prints i eksepsjonell kvalitet i ønsket størrelse og materiale.",
    wall: "Dekorer dine vegger med et personlig og betydningsfullt kunstverk som varer livet ut eller gi det samme i gave.",
    process: {
      title: "Slik fungerer det",
      steps: [
        {
          title: "Foto",
          text: "Vi fanger det unike i hvert øye med toppmoderne utstyr.",
        },
        {
          title: "Redigering",
          text: "Vi fremhever detaljer og farger uten å endre det naturlige utseendet.",
        },
        {
          title: "Print",
          text: "Eksepsjonell kvalitet i ønsket størrelse og materiale.",
        },
        {
          title: "Vegg",
          text: "Et personlig kunstverk til veggen — eller en gave som varer.",
        },
      ],
    },
    title1: "Eviggjør din iris",
    text1:
      "Ved hjelp av topp-moderne utstyr for foto og print, fanger vi det unike i hvert øye og eviggjør det i et kunstverk i høyeste kvalitet.",
    title2: "Del det med nære og kjære",
    text2:
      "En betydningsfull opplevelse for deg selv, med familie eller venner. Ta med noen du er glad i og del opplevelsen!",
    title3: "Gave med mening",
    text3:
      "Du kan også gi Instant Iris i gave i form av gavekort, som du får kjøpt hos oss i butikk. Gi en gave som varer.",
    tabs: {
      fotoprint: {
        label: "Fotoprint",
        description:
          "Klar samme dag. Høy kvalitet på glanset fotopapir, med valgfri innramming i butikk.",
      },
      acrylic: {
        label: "Akryl",
        description:
          "Premium veggkunst med glansfull, hardbelagt overflate. Leveres på post innen ca. 2 uker.",
      },
      alu: {
        label: "Alu",
        description:
          "Moderne aluminiumstrykk med skarpe detaljer. Leveres på post innen ca. 2 uker.",
      },
    },
    digitalNotice: {
      included: "Digital fil følger alltid med gratis ved kjøp av alle produkter.",
      buyAlone: "Vil du kun ha den digitale filen?",
      showPrices: "Se priser for digital fil",
      hidePrices: "Skjul priser",
    },
  },
  bookAppointment: {
    title: "Kontakt Oss",
    dropIn: "Spør oss om du lurer på noe!",
    description:
      "Lurer du fortsatt på noe? Send oss en melding!",
    tellUs: "Send oss en melding, så svarer vi så snart vi kan.",
    openingHours: {
      title: "Åpningstider",
      wednesday: "Onsdag: 17:30 - 21:30",
      thursday: "Torsdag: 17:30 - 21:30",
      saturday: "Lørdag: 12:00 - 18:00",
      note: "Avtaler må bookes — vi er som regel bare der når vi har timer.",
    },
    location: {
      title: "Bergen",
      address: "Steinkjellergaten 2, 5003 Bergen",
    },
    form: {
      book: "Send oss en melding",
      intro: "Vi svarer vanligvis innen én virkedag.",
      name: "Navn",
      email: "E-post",
      message: "Melding",
      exampleMessage: "Hvilket produkt anbefaler dere for en familie på 5?",
      button: "Send inn",
    },
  },
  FAQs: {
    title: "Forberedelser",
    button1: "Forberedelser",
    button2: "På timen",
    button3: "Etter timen",
    section_1: [
      {
        question: "Må jeg bestille time?",
        answer:
          "Det er lurt! Vi er som regel bare der når vi har avtaler, så det er lurt å booke på forhånd.",
      },
      {
        question: "Hvor er dere?",
        answer: "Du finner oss i Steinkjellergaten 2, 5003 Bergen.",
      },
      {
        question: "Hvor lang tid tar det?",
        answer:
          "Selve bildet er gjort på et blunk. Det kan ta opp til en time før bildet er ferdig printet og rammet inn, avhengig av kompleksitet på designet. Ventetid er sjeldent over 15 minutt.",
      },
      {
        question: "Hva koster det?",
        answer:
          "Det varier veldig ut ifra antall personer, størrelsen på bildet og hvilket materiale du ønsker. Vi har produkter ned til 499kr!",
      },
      {
        question: "Hvilke betalingsmetoder har dere?",
        answer: "Vi tar både kort og kontant, men vi foretrekker kort!",
      },
      {
        question: "Er det noen aldersbegrensninger?",
        answer:
          "Nei! Men barn bør helst være noen år gammel, siden det krever å sitte stille med hodet støttet mens bildet blir tatt.",
      },
      {
        question: "Hvor mange kan være på ett bilde?",
        answer:
          "Opp til 5 stk! Hvis det er mer enn det så kan dere kontakte oss så finner vi en løsning.",
      },
    ],
    section_2: [
      {
        question: "Er det ubehagelig?",
        answer:
          "Nei! Vi er aldri borti øyet ditt. Det er et helt vanlig kamera.",
      },
      {
        question: "Får jeg produktet med en gang?",
        answer:
          "Ja! Vi printer og rammer inn bildet på timen om du vil det. For større produkter i andre materialer får du det i posten innen ca 2 uker.",
      },
      {
        question: "Hva med kontaktlinser?",
        answer:
          "Du kan bruke kontaktlinser, men vi anbefaler at de tas ut under bildet. Dette er for å forhindre gjenskinn som kan redusere kvaliteten på bildet.",
      },
      {
        question: "Hvilke størrelser og materiale har dere?",
        answer: `Vi har en rekke forskjellige produkter i størrelser fra 20x20cm til 150cm, i både kvadrat, rektangulært og sirkel. Se mer om hva vi tilbyr på "Konsept" siden.`,
      },
      {
        question: "Hva med smittefare?",
        answer:
          "Vi følger alle smittevernsregler, og desinfiserer utstyr mellom hver kunde.",
      },
    ],
    section_3: [
      {
        question: "Hvor lang tid tar det å levere?",
        answer:
          "Fotoprints blir ferdig på timen, mens større produkter tar ca 2 uker.",
      },
      {
        question: "Bildet har mangler eller er skadet, hva gjør jeg?",
        answer:
          "Kontakt oss så finner vi en løsning! Om det viser seg at det er vår eller leverandøren sin feil så får du selvfølgelig et nytt produkt.",
      },
    ],
  },
  Gallery: {
    title: "Galleri",
  },
  priceCalculator: {
    title: "Prisberegner",
    irisCount: "Antall iris:",
    size: "Størrelse",
    shape: "Form:",
    includeFrame: "Inkluder ramme",
    frameType: "Rammetype:",
    total: "Totalt",
    contactUs: "Kontakt oss på e-post eller i butikken for produkter med mer enn",
    iris: "iris",
  },
  footer: {
    contactUs: "Kontakt Oss",
    openingHours: "Åpningstider",
    bookingRequired: "Avtaler må bookes",
    wednesday: "Onsdag: 17:30 - 21:30",
    thursday: "Torsdag: 17:30 - 21:30",
    saturday: "Lørdag: 12:00 - 18:00",
  },
};

export default translation;
